export default __webpack_public_path__ + "static/media/icon-add-new-categories.a7bdfe8e.svg";